import React from 'react'
import { Grid, Button } from '@material-ui/core'
import './Style/crearFormulario.scss'

import Table41 from './Tables/TablesSec4/Table41'
import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../context/EligibilityContext'

const ElegibilidadSec4View = (props) => {
  const { goToStep } = props
  const { EligibilityForm } = useFormElegibilidad()

  const [, dispatch] = useEligibility()

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 5 })
    goToStep(5)
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    goToStep(3)
  }

  return (
    <>
      <form id="sec4-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">GÉNERO</h1>
          <br />
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              1.- Seleccione el tipo de actividades dentro de la MIPYME que son
              realizadas por mujeres y hombres (Obligatorio)
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Table41
              idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
            ></Table41>
          </Grid>

          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  <Button
                    onClick={() => next()}
                    className="button__wizard button__next"
                    disabled={false}
                  >
                    Siguiente
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSec4View
